<template>
  <UModal
    :dismissible="false"
    :close="false"
    :title="title"
    :description="t('comps.actionModalConfirm.description')"
    :ui="{
      title: 'text-(--ui-text-highlighted) font-semibold text-2xl',
      description: 'mt-1 text-(--ui-text-muted) text-md',
    }"
  >
    <template #footer>
      <UButton
        :label="t('comps.actionModalConfirm.btnYes')"
        color="neutral"
        variant="subtle"
        size="xl"
        class="!px-8"
        :loading="isLoading"
        @click="emit('confirm')"
      />
      <UButton
        :label="t('comps.actionModalConfirm.btnNo')"
        size="xl"
        color="neutral"
        variant="subtle"
        class="!px-8"
        @click="emit('close')"
      />
    </template>
  </UModal>
</template>

    <!-- <template #body>
      <p class="text-2xl mb-6">
        <span v-if="actionType === 'share'">
          {{ t('comps.actionModalConfirm.titleShare') }}
        </span>
        <span v-else-if="actionType === 'contact'">
          {{ t('comps.actionModalConfirm.titleContact', { name: contactName, platform: actionPlatform }) }}
        </span>
        <span v-else>
          {{ t('comps.actionModalConfirm.titleOther') }}
        </span>
      </p>
    </template> -->

<script setup lang="ts">
const emit = defineEmits(['confirm', 'close'])

const props = defineProps({
  isLoading: {
    type: Boolean,
    required: true,
    // default: false,
  },
  actionType: {
    type: String,
    required: true,
    // default: undefined,
  },
  actionPlatform: {
    type: String,
    required: false,
    default: undefined,
  },
  contactName: {
    type: String,
    required: false,
    default: undefined,
  },
})

const title = computed(() => {
  if (props.actionType === 'share') {
    return t('comps.actionModalConfirm.titleShare')
  }
  else if (props.actionType === 'contact') {
    return t('comps.actionModalConfirm.titleContact', { name: props.contactName || 'name_missing', platform: props.actionPlatform || 'platform_missing' })
  }
  else {
    return t('comps.actionModalConfirm.titleOther')
  }
})
</script>
